export default "__VITE_ASSET__c898d6a0__"